import { masks } from "@uenf/layout";

masks.money = {
  mask: Number,
  scale: 2,
  radix: ",",
  mapToRadix: [],
  padFractionalZeros: true,
  normalizeZeros: true
};
